import { Flex, Avatar, Heading, Icon, Button } from '@televet/kibble-ui';
import { toggleConversationDetailsModal } from 'pages/Conversations/state/conversationsSlice';
import React, { useCallback } from 'react';
import { PetParentAvatar } from 'shared/components/Avatars';
import { IAvatarGroupSelectOption } from 'shared/components/Avatars/AvatarGroupSelect';
import { useSidePanelSearch } from 'shared/components/SidePanel/components/SearchPanel/state/providers/SearchPanelProvider';
import { useAppDispatch } from 'state/hooks';
import { formatNames } from '../../MessageComposer/Toolbar/utils';

interface PetParentSelectorProps {
  petParentAvatars: IAvatarGroupSelectOption[];
  isOverlay?: boolean;
}

export function PetParentSelector({ petParentAvatars, isOverlay }: PetParentSelectorProps): JSX.Element {
  const { closeSideBarPanel } = useSidePanelSearch();
  const dispatch = useAppDispatch();

  const openDetailsModal = useCallback(() => {
    dispatch(toggleConversationDetailsModal({ isOpen: true }));
    closeSideBarPanel();
  }, [dispatch, closeSideBarPanel]);

  return (
    <Button variant="ghostNeutral" border="none" height="auto" minWidth="auto" p={2} gap={2} onClick={openDetailsModal}>
      <Flex>
        {petParentAvatars.length > 0 && (
          <>
            <PetParentAvatar
              clinicPetParent={petParentAvatars[0].clinicPetParent}
              size="lg"
              isGrouped
              index={0}
              zIndex={petParentAvatars.length}
              clearConversationIdOnView={true}
            />
            {petParentAvatars.length > 1 &&
              (petParentAvatars.length === 2 ? (
                <PetParentAvatar
                  clinicPetParent={petParentAvatars[1].clinicPetParent}
                  size="lg"
                  isGrouped
                  index={1}
                  zIndex={1}
                  clearConversationIdOnView={true}
                />
              ) : (
                <Avatar
                  size="lg"
                  name={`+ ${petParentAvatars.length - 1}`}
                  ml={-2}
                  tooltipPlacement="top"
                  tooltipText={petParentAvatars
                    .slice(1)
                    .map((p) => p.value.displayName)
                    .join(', ')}
                />
              ))}
          </>
        )}
      </Flex>
      <Heading size="sm">
        {formatNames(
          petParentAvatars.map(({ text }) => text),
          isOverlay ? 25 : 40,
        )}
      </Heading>
      <Icon name="chevronDown" size="sm" alignSelf="center" />
    </Button>
  );
}
